import { render } from "./LoadPermissionTab.vue?vue&type=template&id=c4a27616"
import script from "./LoadPermissionTab.vue?vue&type=script&lang=js"
export * from "./LoadPermissionTab.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/tmulag_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__